import React, { useState } from 'react';
import Head from 'next/head';
import { Grid } from '@mui/material';
import { useRouter } from 'next/router';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

import { DrawerLayout, TaskLayout } from '@layouts';
import {
  AddVehicleForm,
  PermissionsGate,
  TabsV2,
  TaskDetailScrollableSection,
  FACalendar,
  FAEuroIcon,
  FAProductsIcon,
} from '@components';
import { ButtonV2 } from 'components/common/ui';
import { useAddFleetVehicleOperations } from '@hooks';
import { showError, showSuccess } from '@utils';
import { fleetVehiclesServices } from '@services';

import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';
import { getVehiclePayload } from 'helpers';

export const tabs = [
  {
    label: 'General',
    id: 'general',
    icon: <DirectionsCarIcon data-testid="DirectionsCarIcon" />,
  },
  {
    label: 'Order',
    id: 'order',
    icon: <FAProductsIcon />,
  },
  { label: 'Customs', id: 'customs', icon: <FACalendar /> },
  { label: 'Payment', id: 'payment', icon: <FAEuroIcon /> },
];

const NewVehicle = () => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { colors, dealers, sourcingTypes } = useAddFleetVehicleOperations();

  const handleSubmit = async (values) => {
    const payload = getVehiclePayload(values);
    try {
      setLoading(true);
      await fleetVehiclesServices.addVehicle(payload);
      showSuccess('The vehicle is created successfully!');
      router.push('/vehicles');
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  const renderHeaderOptions = () => {
    return (
      <PermissionsGate entity={ENTITIES_PERMISIONS.WriteVehicles}>
        <ButtonV2 disabled={loading} type="submit" form="add-vehicle-form">
          Save
        </ButtonV2>
      </PermissionsGate>
    );
  };

  return (
    <>
      <Head>
        <title>Add New Vehicle</title>
        <meta name="description" content="Instacar ledger" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <TaskLayout
        task="New"
        entity={ENTITIES_PERMISIONS.ReadVehicles}
        renderHeaderOptions={renderHeaderOptions}
      >
        <Grid container alignItems="center" spacing={1} justifyContent="center">
          <Grid size={{ xs: 12, md: 8 }}>
            <TabsV2 tabs={tabs} observerRootId="vehicle-details" />
            <TaskDetailScrollableSection id="vehicle-details">
              <AddVehicleForm
                onSubmit={handleSubmit}
                colors={colors}
                dealers={dealers}
                sourcingTypes={sourcingTypes}
              />
            </TaskDetailScrollableSection>
          </Grid>
        </Grid>
      </TaskLayout>
    </>
  );
};

NewVehicle.getLayout = (page) => {
  return <DrawerLayout>{page}</DrawerLayout>;
};

export default NewVehicle;
